export default __webpack_public_path__ + "static/media/airplane.4b98ce33.png";